/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export var OwnerEnum;
(function (OwnerEnum) {
    OwnerEnum["LEGAL_DEPOSITS"] = "LEGAL_DEPOSITS";
    OwnerEnum["PUBLISHERS"] = "PUBLISHERS";
})(OwnerEnum || (OwnerEnum = {}));
export var GetPublishersParams1OwnerEnum;
(function (GetPublishersParams1OwnerEnum) {
    GetPublishersParams1OwnerEnum["LEGAL_DEPOSITS"] = "LEGAL_DEPOSITS";
    GetPublishersParams1OwnerEnum["PUBLISHERS"] = "PUBLISHERS";
})(GetPublishersParams1OwnerEnum || (GetPublishersParams1OwnerEnum = {}));
/** @default "publisher" */
export var GroupByEnum;
(function (GroupByEnum) {
    GroupByEnum["Publisher"] = "publisher";
    GroupByEnum["Date"] = "date";
})(GroupByEnum || (GroupByEnum = {}));
/** @default "publisher" */
export var GetTitlesPendingVerificationParams1GroupByEnum;
(function (GetTitlesPendingVerificationParams1GroupByEnum) {
    GetTitlesPendingVerificationParams1GroupByEnum["Publisher"] = "publisher";
    GetTitlesPendingVerificationParams1GroupByEnum["Date"] = "date";
})(GetTitlesPendingVerificationParams1GroupByEnum || (GetTitlesPendingVerificationParams1GroupByEnum = {}));
export var StatusEnum;
(function (StatusEnum) {
    StatusEnum["NEEDS_CONFIRMATION"] = "NEEDS_CONFIRMATION";
    StatusEnum["PUBLISHER_REQUEST_CREATED"] = "PUBLISHER_REQUEST_CREATED";
    StatusEnum["PENDING_MANUAL"] = "PENDING_MANUAL";
})(StatusEnum || (StatusEnum = {}));
export var GetTitlesNeedsPublisherParams1StatusEnum;
(function (GetTitlesNeedsPublisherParams1StatusEnum) {
    GetTitlesNeedsPublisherParams1StatusEnum["NEEDS_CONFIRMATION"] = "NEEDS_CONFIRMATION";
    GetTitlesNeedsPublisherParams1StatusEnum["PUBLISHER_REQUEST_CREATED"] = "PUBLISHER_REQUEST_CREATED";
    GetTitlesNeedsPublisherParams1StatusEnum["PENDING_MANUAL"] = "PENDING_MANUAL";
})(GetTitlesNeedsPublisherParams1StatusEnum || (GetTitlesNeedsPublisherParams1StatusEnum = {}));
export var GetTitleDistributionStatusEnum;
(function (GetTitleDistributionStatusEnum) {
    GetTitleDistributionStatusEnum["EXPECTED"] = "EXPECTED";
    GetTitleDistributionStatusEnum["RECEIVED"] = "RECEIVED";
    GetTitleDistributionStatusEnum["MISSING"] = "MISSING";
    GetTitleDistributionStatusEnum["ENFORCED"] = "ENFORCED";
})(GetTitleDistributionStatusEnum || (GetTitleDistributionStatusEnum = {}));
/** Nový status periodika */
export var UpdatePeriodicalStatusStatusEnum;
(function (UpdatePeriodicalStatusStatusEnum) {
    UpdatePeriodicalStatusStatusEnum["FirstIssuePending"] = "first_issue_pending";
    UpdatePeriodicalStatusStatusEnum["Subscribed"] = "subscribed";
    UpdatePeriodicalStatusStatusEnum["Cancelled"] = "cancelled";
})(UpdatePeriodicalStatusStatusEnum || (UpdatePeriodicalStatusStatusEnum = {}));
export var StatusEnum1;
(function (StatusEnum1) {
    StatusEnum1["EXPECTED"] = "EXPECTED";
    StatusEnum1["RECEIVED"] = "RECEIVED";
    StatusEnum1["MISSING"] = "MISSING";
})(StatusEnum1 || (StatusEnum1 = {}));
export var GetPeriodicalIssuesParams1StatusEnum;
(function (GetPeriodicalIssuesParams1StatusEnum) {
    GetPeriodicalIssuesParams1StatusEnum["EXPECTED"] = "EXPECTED";
    GetPeriodicalIssuesParams1StatusEnum["RECEIVED"] = "RECEIVED";
    GetPeriodicalIssuesParams1StatusEnum["MISSING"] = "MISSING";
})(GetPeriodicalIssuesParams1StatusEnum || (GetPeriodicalIssuesParams1StatusEnum = {}));
export var UpdatePeriodicalFrequencyFrequencyEnum;
(function (UpdatePeriodicalFrequencyFrequencyEnum) {
    UpdatePeriodicalFrequencyFrequencyEnum["DAILY"] = "DAILY";
    UpdatePeriodicalFrequencyFrequencyEnum["WEEKLY"] = "WEEKLY";
    UpdatePeriodicalFrequencyFrequencyEnum["BIWEEKLY"] = "BIWEEKLY";
    UpdatePeriodicalFrequencyFrequencyEnum["MONTHLY"] = "MONTHLY";
    UpdatePeriodicalFrequencyFrequencyEnum["QUARTERLY"] = "QUARTERLY";
    UpdatePeriodicalFrequencyFrequencyEnum["YEARLY"] = "YEARLY";
    UpdatePeriodicalFrequencyFrequencyEnum["IRREGULAR"] = "IRREGULAR";
})(UpdatePeriodicalFrequencyFrequencyEnum || (UpdatePeriodicalFrequencyFrequencyEnum = {}));
/** Počáteční status je NOT_RECEIVED */
export var CreateSpecialIssueDeliveryStatusEnum;
(function (CreateSpecialIssueDeliveryStatusEnum) {
    CreateSpecialIssueDeliveryStatusEnum["NOT_RECEIVED"] = "NOT_RECEIVED";
    CreateSpecialIssueDeliveryStatusEnum["PARTIALLY_RECEIVED"] = "PARTIALLY_RECEIVED";
    CreateSpecialIssueDeliveryStatusEnum["RECEIVED"] = "RECEIVED";
})(CreateSpecialIssueDeliveryStatusEnum || (CreateSpecialIssueDeliveryStatusEnum = {}));
/** ORANGE = speciální číslo k potvrzení */
export var CreateSpecialIssueAlertLevelEnum;
(function (CreateSpecialIssueAlertLevelEnum) {
    CreateSpecialIssueAlertLevelEnum["ORANGE"] = "ORANGE";
    CreateSpecialIssueAlertLevelEnum["RED"] = "RED";
})(CreateSpecialIssueAlertLevelEnum || (CreateSpecialIssueAlertLevelEnum = {}));
/** Typ speciálního čísla */
export var CreateSpecialIssueSpecialTypeEnum;
(function (CreateSpecialIssueSpecialTypeEnum) {
    CreateSpecialIssueSpecialTypeEnum["Double"] = "double";
    CreateSpecialIssueSpecialTypeEnum["Supplement"] = "supplement";
    CreateSpecialIssueSpecialTypeEnum["Christmas"] = "christmas";
    CreateSpecialIssueSpecialTypeEnum["Anniversary"] = "anniversary";
    CreateSpecialIssueSpecialTypeEnum["Other"] = "other";
})(CreateSpecialIssueSpecialTypeEnum || (CreateSpecialIssueSpecialTypeEnum = {}));
/** Status změněn na RECEIVED */
export var ConfirmSpecialIssueDeliveryStatusEnum;
(function (ConfirmSpecialIssueDeliveryStatusEnum) {
    ConfirmSpecialIssueDeliveryStatusEnum["RECEIVED"] = "RECEIVED";
})(ConfirmSpecialIssueDeliveryStatusEnum || (ConfirmSpecialIssueDeliveryStatusEnum = {}));
/** received = automaticky přijato, confirmation_required = vyžaduje potvrzení, duplicate = druhý výtisk dnes, not_found = ISBN nenalezeno */
export var ScanIsbnForReceiptActionEnum;
(function (ScanIsbnForReceiptActionEnum) {
    ScanIsbnForReceiptActionEnum["Received"] = "received";
    ScanIsbnForReceiptActionEnum["ConfirmationRequired"] = "confirmation_required";
    ScanIsbnForReceiptActionEnum["Duplicate"] = "duplicate";
    ScanIsbnForReceiptActionEnum["NotFound"] = "not_found";
})(ScanIsbnForReceiptActionEnum || (ScanIsbnForReceiptActionEnum = {}));
/** @default "standard" */
export var ScanIsbnForReceiptModeEnum;
(function (ScanIsbnForReceiptModeEnum) {
    ScanIsbnForReceiptModeEnum["Standard"] = "standard";
    ScanIsbnForReceiptModeEnum["Tablet"] = "tablet";
    ScanIsbnForReceiptModeEnum["Silent"] = "silent";
})(ScanIsbnForReceiptModeEnum || (ScanIsbnForReceiptModeEnum = {}));
export var SendEnforcementDeliveryStatusEnum;
(function (SendEnforcementDeliveryStatusEnum) {
    SendEnforcementDeliveryStatusEnum["SENT"] = "SENT";
    SendEnforcementDeliveryStatusEnum["DELIVERED"] = "DELIVERED";
    SendEnforcementDeliveryStatusEnum["BOUNCED"] = "BOUNCED";
})(SendEnforcementDeliveryStatusEnum || (SendEnforcementDeliveryStatusEnum = {}));
export var SendEnforcementChannelEnum;
(function (SendEnforcementChannelEnum) {
    SendEnforcementChannelEnum["EMAIL"] = "EMAIL";
    SendEnforcementChannelEnum["DATA_BOX"] = "DATA_BOX";
    SendEnforcementChannelEnum["POSTAL"] = "POSTAL";
})(SendEnforcementChannelEnum || (SendEnforcementChannelEnum = {}));
export var AddCommunicationTypeEnum;
(function (AddCommunicationTypeEnum) {
    AddCommunicationTypeEnum["PHONE"] = "PHONE";
    AddCommunicationTypeEnum["POSTAL"] = "POSTAL";
    AddCommunicationTypeEnum["EMAIL"] = "EMAIL";
    AddCommunicationTypeEnum["IN_PERSON"] = "IN_PERSON";
})(AddCommunicationTypeEnum || (AddCommunicationTypeEnum = {}));
export var MarkTitlesDeliveredEnforcementStatusEnum;
(function (MarkTitlesDeliveredEnforcementStatusEnum) {
    MarkTitlesDeliveredEnforcementStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    MarkTitlesDeliveredEnforcementStatusEnum["CLOSED"] = "CLOSED";
})(MarkTitlesDeliveredEnforcementStatusEnum || (MarkTitlesDeliveredEnforcementStatusEnum = {}));
export var CloseEnforcementClosureReasonEnum;
(function (CloseEnforcementClosureReasonEnum) {
    CloseEnforcementClosureReasonEnum["Delivered"] = "delivered";
    CloseEnforcementClosureReasonEnum["NotEnforceable"] = "not_enforceable";
    CloseEnforcementClosureReasonEnum["Other"] = "other";
})(CloseEnforcementClosureReasonEnum || (CloseEnforcementClosureReasonEnum = {}));
export var GetEnforcementTimelineTypeEnum;
(function (GetEnforcementTimelineTypeEnum) {
    GetEnforcementTimelineTypeEnum["REMINDER"] = "REMINDER";
    GetEnforcementTimelineTypeEnum["URGENCE"] = "URGENCE";
    GetEnforcementTimelineTypeEnum["PHONE"] = "PHONE";
    GetEnforcementTimelineTypeEnum["POSTAL"] = "POSTAL";
    GetEnforcementTimelineTypeEnum["EMAIL"] = "EMAIL";
    GetEnforcementTimelineTypeEnum["DELIVERED"] = "DELIVERED";
})(GetEnforcementTimelineTypeEnum || (GetEnforcementTimelineTypeEnum = {}));
export var TypeEnum;
(function (TypeEnum) {
    TypeEnum["NATIONAL"] = "NATIONAL";
    TypeEnum["REGIONAL"] = "REGIONAL";
    TypeEnum["SPECIAL"] = "SPECIAL";
})(TypeEnum || (TypeEnum = {}));
export var GetLibrariesParams1TypeEnum;
(function (GetLibrariesParams1TypeEnum) {
    GetLibrariesParams1TypeEnum["NATIONAL"] = "NATIONAL";
    GetLibrariesParams1TypeEnum["REGIONAL"] = "REGIONAL";
    GetLibrariesParams1TypeEnum["SPECIAL"] = "SPECIAL";
})(GetLibrariesParams1TypeEnum || (GetLibrariesParams1TypeEnum = {}));
export var SyncTitlesStatusEnum;
(function (SyncTitlesStatusEnum) {
    SyncTitlesStatusEnum["RUNNING"] = "RUNNING";
    SyncTitlesStatusEnum["COMPLETED"] = "COMPLETED";
    SyncTitlesStatusEnum["FAILED"] = "FAILED";
})(SyncTitlesStatusEnum || (SyncTitlesStatusEnum = {}));
export var GetSyncStatusTypeEnum;
(function (GetSyncStatusTypeEnum) {
    GetSyncStatusTypeEnum["TITLES_SYNC"] = "TITLES_SYNC";
    GetSyncStatusTypeEnum["PUBLISHERS_SYNC"] = "PUBLISHERS_SYNC";
    GetSyncStatusTypeEnum["REMINDERS"] = "REMINDERS";
})(GetSyncStatusTypeEnum || (GetSyncStatusTypeEnum = {}));
export var GetSyncStatusStatusEnum;
(function (GetSyncStatusStatusEnum) {
    GetSyncStatusStatusEnum["RUNNING"] = "RUNNING";
    GetSyncStatusStatusEnum["COMPLETED"] = "COMPLETED";
    GetSyncStatusStatusEnum["FAILED"] = "FAILED";
})(GetSyncStatusStatusEnum || (GetSyncStatusStatusEnum = {}));
export var TitleSourceEnum;
(function (TitleSourceEnum) {
    TitleSourceEnum["AGENTURA"] = "AGENTURA";
    TitleSourceEnum["SOUBORNY_KATALOG"] = "SOUBORNY_KATALOG";
})(TitleSourceEnum || (TitleSourceEnum = {}));
export var TitleStatusEnum;
(function (TitleStatusEnum) {
    TitleStatusEnum["PENDING"] = "PENDING";
    TitleStatusEnum["ACTIVE"] = "ACTIVE";
    TitleStatusEnum["RECEIVED"] = "RECEIVED";
    TitleStatusEnum["MISSING"] = "MISSING";
    TitleStatusEnum["ENFORCED"] = "ENFORCED";
})(TitleStatusEnum || (TitleStatusEnum = {}));
export var PeriodicalFrequencyEnum;
(function (PeriodicalFrequencyEnum) {
    PeriodicalFrequencyEnum["DAILY"] = "DAILY";
    PeriodicalFrequencyEnum["FOUR_WEEKLY"] = "FOUR_WEEKLY";
    PeriodicalFrequencyEnum["THREE_WEEKLY"] = "THREE_WEEKLY";
    PeriodicalFrequencyEnum["SEMIWEEKLY"] = "SEMIWEEKLY";
    PeriodicalFrequencyEnum["WEEKLY"] = "WEEKLY";
    PeriodicalFrequencyEnum["THREE_MONTHLY"] = "THREE_MONTHLY";
    PeriodicalFrequencyEnum["BIWEEKLY"] = "BIWEEKLY";
    PeriodicalFrequencyEnum["SEMIMONTHLY"] = "SEMIMONTHLY";
    PeriodicalFrequencyEnum["MONTHLY"] = "MONTHLY";
    PeriodicalFrequencyEnum["ELEVEN_YEARLY"] = "ELEVEN_YEARLY";
    PeriodicalFrequencyEnum["TEN_YEARLY"] = "TEN_YEARLY";
    PeriodicalFrequencyEnum["NINE_YEARLY"] = "NINE_YEARLY";
    PeriodicalFrequencyEnum["EIGHT_YEARLY"] = "EIGHT_YEARLY";
    PeriodicalFrequencyEnum["SEVEN_YEARLY"] = "SEVEN_YEARLY";
    PeriodicalFrequencyEnum["BIMONTHLY"] = "BIMONTHLY";
    PeriodicalFrequencyEnum["FIVE_YEARLY"] = "FIVE_YEARLY";
    PeriodicalFrequencyEnum["QUARTERLY"] = "QUARTERLY";
    PeriodicalFrequencyEnum["THREE_YEARLY"] = "THREE_YEARLY";
    PeriodicalFrequencyEnum["SEMIANNUAL"] = "SEMIANNUAL";
    PeriodicalFrequencyEnum["ANNUAL"] = "ANNUAL";
    PeriodicalFrequencyEnum["BIENNIAL"] = "BIENNIAL";
    PeriodicalFrequencyEnum["TRIENNIAL"] = "TRIENNIAL";
    PeriodicalFrequencyEnum["IRREGULAR"] = "IRREGULAR";
    PeriodicalFrequencyEnum["UNKNOWN"] = "UNKNOWN";
})(PeriodicalFrequencyEnum || (PeriodicalFrequencyEnum = {}));
export var PeriodicalIssueStatusEnum;
(function (PeriodicalIssueStatusEnum) {
    PeriodicalIssueStatusEnum["EXPECTED"] = "EXPECTED";
    PeriodicalIssueStatusEnum["RECEIVED"] = "RECEIVED";
    PeriodicalIssueStatusEnum["MISSING"] = "MISSING";
})(PeriodicalIssueStatusEnum || (PeriodicalIssueStatusEnum = {}));
/** REMINDER = automatická připomínka, URGENCE = ruční vymáhání */
export var EnforcementTypeEnum;
(function (EnforcementTypeEnum) {
    EnforcementTypeEnum["REMINDER"] = "REMINDER";
    EnforcementTypeEnum["URGENCE"] = "URGENCE";
})(EnforcementTypeEnum || (EnforcementTypeEnum = {}));
export var EnforcementStatusEnum;
(function (EnforcementStatusEnum) {
    EnforcementStatusEnum["CREATED"] = "CREATED";
    EnforcementStatusEnum["SENT"] = "SENT";
    EnforcementStatusEnum["IN_PROGRESS"] = "IN_PROGRESS";
    EnforcementStatusEnum["DELIVERED"] = "DELIVERED";
    EnforcementStatusEnum["CLOSED"] = "CLOSED";
})(EnforcementStatusEnum || (EnforcementStatusEnum = {}));
export var EnforcementClosureReasonEnum;
(function (EnforcementClosureReasonEnum) {
    EnforcementClosureReasonEnum["Delivered"] = "delivered";
    EnforcementClosureReasonEnum["NotEnforceable"] = "not_enforceable";
    EnforcementClosureReasonEnum["Other"] = "other";
})(EnforcementClosureReasonEnum || (EnforcementClosureReasonEnum = {}));
/** @default "URGENCE" */
export var EnforcementCreateTypeEnum;
(function (EnforcementCreateTypeEnum) {
    EnforcementCreateTypeEnum["URGENCE"] = "URGENCE";
})(EnforcementCreateTypeEnum || (EnforcementCreateTypeEnum = {}));
/** Typ knihovny */
export var LibraryTypeEnum;
(function (LibraryTypeEnum) {
    LibraryTypeEnum["NATIONAL"] = "NATIONAL";
    LibraryTypeEnum["REGIONAL"] = "REGIONAL";
    LibraryTypeEnum["SPECIAL"] = "SPECIAL";
})(LibraryTypeEnum || (LibraryTypeEnum = {}));
/** Typ knihovny */
export var LibraryCreateTypeEnum;
(function (LibraryCreateTypeEnum) {
    LibraryCreateTypeEnum["NATIONAL"] = "NATIONAL";
    LibraryCreateTypeEnum["REGIONAL"] = "REGIONAL";
    LibraryCreateTypeEnum["SPECIAL"] = "SPECIAL";
})(LibraryCreateTypeEnum || (LibraryCreateTypeEnum = {}));
/** Typ knihovny */
export var LibraryUpdateTypeEnum;
(function (LibraryUpdateTypeEnum) {
    LibraryUpdateTypeEnum["NATIONAL"] = "NATIONAL";
    LibraryUpdateTypeEnum["REGIONAL"] = "REGIONAL";
    LibraryUpdateTypeEnum["SPECIAL"] = "SPECIAL";
})(LibraryUpdateTypeEnum || (LibraryUpdateTypeEnum = {}));
/** Legal form of the publisher */
export var PublisherLegalFormEnum;
(function (PublisherLegalFormEnum) {
    PublisherLegalFormEnum["LEGAL"] = "LEGAL";
    PublisherLegalFormEnum["NATURAL"] = "NATURAL";
    PublisherLegalFormEnum["UNKNOWN"] = "UNKNOWN";
})(PublisherLegalFormEnum || (PublisherLegalFormEnum = {}));
/** Current status of the publisher */
export var PublisherStatusEnum;
(function (PublisherStatusEnum) {
    PublisherStatusEnum["REQUEST"] = "REQUEST";
    PublisherStatusEnum["REJECTED"] = "REJECTED";
    PublisherStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherStatusEnum["CLOSING"] = "CLOSING";
    PublisherStatusEnum["CLOSED"] = "CLOSED";
})(PublisherStatusEnum || (PublisherStatusEnum = {}));
/** Owner agency of the publisher record */
export var PublisherOwnerEnum;
(function (PublisherOwnerEnum) {
    PublisherOwnerEnum["LEGAL_DEPOSITS"] = "LEGAL_DEPOSITS";
    PublisherOwnerEnum["PUBLISHERS"] = "PUBLISHERS";
})(PublisherOwnerEnum || (PublisherOwnerEnum = {}));
/** Registration agency responsible for the publisher */
export var PublisherRegistrationAgencyEnum;
(function (PublisherRegistrationAgencyEnum) {
    PublisherRegistrationAgencyEnum["ISBN"] = "ISBN";
    PublisherRegistrationAgencyEnum["ISMN"] = "ISMN";
})(PublisherRegistrationAgencyEnum || (PublisherRegistrationAgencyEnum = {}));
/** Type of the publisher */
export var PublisherPublisherTypeEnum;
(function (PublisherPublisherTypeEnum) {
    PublisherPublisherTypeEnum["COMMON"] = "COMMON";
    PublisherPublisherTypeEnum["SPECIAL"] = "SPECIAL";
})(PublisherPublisherTypeEnum || (PublisherPublisherTypeEnum = {}));
/** Data source of the publisher record */
export var PublisherSourceEnum;
(function (PublisherSourceEnum) {
    PublisherSourceEnum["USERS"] = "USERS";
    PublisherSourceEnum["PUBLISHERS"] = "PUBLISHERS";
    PublisherSourceEnum["AGENCY"] = "AGENCY";
})(PublisherSourceEnum || (PublisherSourceEnum = {}));
/** Data source origin of this address */
export var PublisherAddressSourceEnum;
(function (PublisherAddressSourceEnum) {
    PublisherAddressSourceEnum["USERS"] = "USERS";
    PublisherAddressSourceEnum["PUBLISHERS"] = "PUBLISHERS";
    PublisherAddressSourceEnum["AGENCY"] = "AGENCY";
})(PublisherAddressSourceEnum || (PublisherAddressSourceEnum = {}));
/** Type of contact (EMAIL, PHONE, etc.) */
export var PublisherContactTypeEnum;
(function (PublisherContactTypeEnum) {
    PublisherContactTypeEnum["PHONE"] = "PHONE";
    PublisherContactTypeEnum["EMAIL"] = "EMAIL";
    PublisherContactTypeEnum["WEB"] = "WEB";
    PublisherContactTypeEnum["DATA_BOX"] = "DATA_BOX";
})(PublisherContactTypeEnum || (PublisherContactTypeEnum = {}));
/** Source system from which this contact was imported */
export var PublisherContactSourceEnum;
(function (PublisherContactSourceEnum) {
    PublisherContactSourceEnum["USERS"] = "USERS";
    PublisherContactSourceEnum["PUBLISHERS"] = "PUBLISHERS";
    PublisherContactSourceEnum["AGENCY"] = "AGENCY";
})(PublisherContactSourceEnum || (PublisherContactSourceEnum = {}));
/** Typ kontaktu */
export var PublisherContactInputTypeEnum;
(function (PublisherContactInputTypeEnum) {
    PublisherContactInputTypeEnum["PHONE"] = "PHONE";
    PublisherContactInputTypeEnum["EMAIL"] = "EMAIL";
    PublisherContactInputTypeEnum["WEB"] = "WEB";
    PublisherContactInputTypeEnum["DATA_BOX"] = "DATA_BOX";
})(PublisherContactInputTypeEnum || (PublisherContactInputTypeEnum = {}));
/** Právní forma */
export var PublisherCreateRequestLegalFormEnum;
(function (PublisherCreateRequestLegalFormEnum) {
    PublisherCreateRequestLegalFormEnum["LEGAL"] = "LEGAL";
    PublisherCreateRequestLegalFormEnum["NATURAL"] = "NATURAL";
    PublisherCreateRequestLegalFormEnum["UNKNOWN"] = "UNKNOWN";
})(PublisherCreateRequestLegalFormEnum || (PublisherCreateRequestLegalFormEnum = {}));
/** Právní forma */
export var PublisherUpdateRequestLegalFormEnum;
(function (PublisherUpdateRequestLegalFormEnum) {
    PublisherUpdateRequestLegalFormEnum["LEGAL"] = "LEGAL";
    PublisherUpdateRequestLegalFormEnum["NATURAL"] = "NATURAL";
    PublisherUpdateRequestLegalFormEnum["UNKNOWN"] = "UNKNOWN";
})(PublisherUpdateRequestLegalFormEnum || (PublisherUpdateRequestLegalFormEnum = {}));
/** Contact type (EMAIL, PHONE, etc.) */
export var PublisherContactUpdateTypeEnum;
(function (PublisherContactUpdateTypeEnum) {
    PublisherContactUpdateTypeEnum["PHONE"] = "PHONE";
    PublisherContactUpdateTypeEnum["EMAIL"] = "EMAIL";
    PublisherContactUpdateTypeEnum["WEB"] = "WEB";
    PublisherContactUpdateTypeEnum["DATA_BOX"] = "DATA_BOX";
})(PublisherContactUpdateTypeEnum || (PublisherContactUpdateTypeEnum = {}));
/** Legal form of the publisher (e.g., company, individual) */
export var PublisherUpdateLegalFormEnum;
(function (PublisherUpdateLegalFormEnum) {
    PublisherUpdateLegalFormEnum["LEGAL"] = "LEGAL";
    PublisherUpdateLegalFormEnum["NATURAL"] = "NATURAL";
    PublisherUpdateLegalFormEnum["UNKNOWN"] = "UNKNOWN";
})(PublisherUpdateLegalFormEnum || (PublisherUpdateLegalFormEnum = {}));
/** The type of alternative name */
export var PublisherAlternativeNameTypeEnum;
(function (PublisherAlternativeNameTypeEnum) {
    PublisherAlternativeNameTypeEnum["PREVIOUS"] = "PREVIOUS";
    PublisherAlternativeNameTypeEnum["IMPRINT"] = "IMPRINT";
    PublisherAlternativeNameTypeEnum["ABBREVIATION"] = "ABBREVIATION";
    PublisherAlternativeNameTypeEnum["ORGANIZATION_UNIT"] = "ORGANIZATION_UNIT";
    PublisherAlternativeNameTypeEnum["FOREIGN_LANGUAGE"] = "FOREIGN_LANGUAGE";
})(PublisherAlternativeNameTypeEnum || (PublisherAlternativeNameTypeEnum = {}));
/** The data source of the alternative name */
export var PublisherAlternativeNameSourceEnum;
(function (PublisherAlternativeNameSourceEnum) {
    PublisherAlternativeNameSourceEnum["USERS"] = "USERS";
    PublisherAlternativeNameSourceEnum["PUBLISHERS"] = "PUBLISHERS";
    PublisherAlternativeNameSourceEnum["AGENCY"] = "AGENCY";
})(PublisherAlternativeNameSourceEnum || (PublisherAlternativeNameSourceEnum = {}));
export var LibraryUpdateDtoTypeEnum;
(function (LibraryUpdateDtoTypeEnum) {
    LibraryUpdateDtoTypeEnum["NATIONAL"] = "NATIONAL";
    LibraryUpdateDtoTypeEnum["REGIONAL"] = "REGIONAL";
    LibraryUpdateDtoTypeEnum["SPECIAL"] = "SPECIAL";
})(LibraryUpdateDtoTypeEnum || (LibraryUpdateDtoTypeEnum = {}));
export var LibraryDtoTypeEnum;
(function (LibraryDtoTypeEnum) {
    LibraryDtoTypeEnum["NATIONAL"] = "NATIONAL";
    LibraryDtoTypeEnum["REGIONAL"] = "REGIONAL";
    LibraryDtoTypeEnum["SPECIAL"] = "SPECIAL";
})(LibraryDtoTypeEnum || (LibraryDtoTypeEnum = {}));
/** Legal form of the publisher (e.g., legal entity, natural person) */
export var PublisherCreateLegalFormEnum;
(function (PublisherCreateLegalFormEnum) {
    PublisherCreateLegalFormEnum["LEGAL"] = "LEGAL";
    PublisherCreateLegalFormEnum["NATURAL"] = "NATURAL";
    PublisherCreateLegalFormEnum["UNKNOWN"] = "UNKNOWN";
})(PublisherCreateLegalFormEnum || (PublisherCreateLegalFormEnum = {}));
export var LibraryCreateDtoTypeEnum;
(function (LibraryCreateDtoTypeEnum) {
    LibraryCreateDtoTypeEnum["NATIONAL"] = "NATIONAL";
    LibraryCreateDtoTypeEnum["REGIONAL"] = "REGIONAL";
    LibraryCreateDtoTypeEnum["SPECIAL"] = "SPECIAL";
})(LibraryCreateDtoTypeEnum || (LibraryCreateDtoTypeEnum = {}));
export var PublisherPrefixHistoryStatusEnum;
(function (PublisherPrefixHistoryStatusEnum) {
    PublisherPrefixHistoryStatusEnum["ACTIVE"] = "ACTIVE";
    PublisherPrefixHistoryStatusEnum["CLOSED"] = "CLOSED";
})(PublisherPrefixHistoryStatusEnum || (PublisherPrefixHistoryStatusEnum = {}));
export var PublisherPrefixHistoryAgencyEnum;
(function (PublisherPrefixHistoryAgencyEnum) {
    PublisherPrefixHistoryAgencyEnum["ISBN"] = "ISBN";
    PublisherPrefixHistoryAgencyEnum["ISMN"] = "ISMN";
})(PublisherPrefixHistoryAgencyEnum || (PublisherPrefixHistoryAgencyEnum = {}));
export var PeriodicalLibraryStatusEnum;
(function (PeriodicalLibraryStatusEnum) {
    PeriodicalLibraryStatusEnum["PENDING"] = "PENDING";
    PeriodicalLibraryStatusEnum["SUBSCRIBED"] = "SUBSCRIBED";
    PeriodicalLibraryStatusEnum["EXCLUDED"] = "EXCLUDED";
})(PeriodicalLibraryStatusEnum || (PeriodicalLibraryStatusEnum = {}));
export var PeriodicalDepositStatusEnum;
(function (PeriodicalDepositStatusEnum) {
    PeriodicalDepositStatusEnum["MISSING"] = "MISSING";
    PeriodicalDepositStatusEnum["PARTIAL"] = "PARTIAL";
    PeriodicalDepositStatusEnum["RECEIVED"] = "RECEIVED";
    PeriodicalDepositStatusEnum["PENDING"] = "PENDING";
    PeriodicalDepositStatusEnum["EXCLUDED"] = "EXCLUDED";
    PeriodicalDepositStatusEnum["REQUESTED"] = "REQUESTED";
    PeriodicalDepositStatusEnum["DAMAGED"] = "DAMAGED";
})(PeriodicalDepositStatusEnum || (PeriodicalDepositStatusEnum = {}));
export var IssueKind;
(function (IssueKind) {
    IssueKind["REGULAR"] = "REGULAR";
    IssueKind["IRREGULAR"] = "IRREGULAR";
    IssueKind["SPECIAL_SUB"] = "SPECIAL_SUB";
    IssueKind["SPECIAL_STANDALONE"] = "SPECIAL_STANDALONE";
})(IssueKind || (IssueKind = {}));
